

TPS.DealerTools["PinSearch"] = {

    emailFormSel: '#email-pin-form-wrapper',
    isInitialized: false,
    currentCulture: '',
    searchForm: null,
    searchResults: null,
    monthLabels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    offerCodeSent: false,
    init: function () {

        var _self = TPS.DealerTools.PinSearch;
        _self.currentCulture = document.getElementById('lng').value;

        _self.searchForm = jQuery('#pin-search-form');
        _self.searchResults = jQuery('#pin-search-results');

        if (!_self.isInitialized) {

            TPS.Util.loadWebserviceJS('CMSApp.AV.API.Pin');

            // Check for query string and fill in the PIN input if found
            _self.GetPinFromUrl(window.location.search);

            // bind keyboard events to the search term input
            _self.searchForm.find('#searchTerm')
                .on('keydown', function (e) {
                    // submit the search on return
                    if (e.which === 13) {
                        e.preventDefault();
                        _self.findPin(e.target.value);
                    }

                }).on('keyup', function (e) {
                    // when the value is not empty, then
                    // show the clear button
                    if (e.target.value.length > 0) {
                        _self.searchForm.addClass('has-search-term');
                    } else {
                        _self.searchForm.removeClass('has-search-term');
                    }
                });

            // Clear PIN Results
            _self.searchForm.find('.clear-field').on('click', function (e) {
                e.preventDefault();
                _self.searchForm.removeClass('has-search-term');
                _self.searchForm.find('#searchTerm').val('');
                _self.resetSearchFormErrors();
                _self.searchResults.empty();
            });

            _self.searchForm.find('.submit-field').on('click', function (e) {
                e.preventDefault();
                _self.findPin();
            });

            // Listening PIN Validation Button (Click)
            jQuery(document).on('click', '[data-action="showvalidatepin"]', function (e) {
                e.preventDefault();
                var $this = jQuery(this);

                if (!$this.hasClass('disabled')) {
                    TPS.DealerTools.PinSearch.handleValidatePinButton($this);
                }
            });

            // Listening PIN Validation Button (Enter)
            jQuery(document).on('keydown', '[data-action="showvalidatepin"]', function (e) {
                var $this = jQuery(this);

                if (e.key === 'Enter' || e.keyCode === 13) {
                    e.preventDefault();

                    if (!$this.hasClass('disabled')) {
                        TPS.DealerTools.PinSearch.handleValidatePinButton($this);
                    }
                }
            });

            // Listening PIN Category Radios (Change)
            jQuery(document).on('change', '#pinValidationCategory', function (e) {
                e.preventDefault();
                var category = TPS.Forms.getFormVals('.' + TPS.DealerTools.ValidatePinForm.validatePinFormSelector).pinValidationCategory;
                TPS.DealerTools.VinSearch.handleCategories(jQuery(this), category);
            });

            // Listening VIN Eligibility Button (Click)
            jQuery(document).on('click', '[data-action="verifyvineligibility"]', function (e) {
                e.preventDefault();
                TPS.DealerTools.VinSearch.verifyVinEligibility(jQuery(this));
            });

            // Listening VIN Eligibility Button (Enter)
            jQuery(document).on('keydown', '[data-action="verifyvineligibility"]', function (e) {
                if (e.key === 'Enter' || e.keyCode === 13) {
                    e.preventDefault();
                    TPS.DealerTools.VinSearch.verifyVinEligibility(jQuery(this));
                }
            });

            // Listening VIN Eligibility Input Text (Enter)
            jQuery(document).on('keydown', '#vinNumberInput', function (e) {
                if (e.key === 'Enter' || e.keyCode === 13) {
                    e.preventDefault();
                    var $button = jQuery('[data-action="verifyvineligibility"]');

                    if ($button.length && !$button.hasClass('disabled')) {
                        TPS.DealerTools.VinSearch.verifyVinEligibility($button);
                    }
                }
            });

            // Listening Clear VIN Button (Click)
            jQuery(document).on('click', '[data-action="clearvin"]', function (e) {
                e.preventDefault();
                TPS.DealerTools.VinSearch.VinClear('clear');
            });

            // Listening Clear VIN Button (Enter)
            jQuery(document).on('keydown', '[data-action="clearvin"]', function (e) {
                if (e.key === 'Enter' || e.keyCode === 13) {
                    e.preventDefault();
                    TPS.DealerTools.VinSearch.VinClear('clear');
                }
            });

            // Listening Revalidate PIN Button (Click)
            jQuery(document).on('click', '[data-action="revalidatepin"]', function (e) {
                e.preventDefault();
                TPS.DealerTools.PinSearch.handleRevalidatePinButton(jQuery(this));
            });

            // Listening Revalidate PIN Button (Enter)
            jQuery(document).on('keydown', '[data-action="revalidatepin"]', function (e) {
                if (e.key === 'Enter' || e.keyCode === 13) {
                    e.preventDefault();
                    TPS.DealerTools.PinSearch.handleRevalidatePinButton(jQuery(this));
                }
            });

            jQuery(document).on('click', '[data-action="create-offer-pin"]', function (e) {
                e.preventDefault();
                var _el = $(this);
                var _offerCode = _el.data('offerCode');
                var _offerAmount = _el.data('offerAmount');

                // if we are not already sending
                // a code to the BE
                if (!_self.offerCodeSent) {
                    _el.append('<span class="tps-icon fas fa-circle-notch fa-spin" aria-hidden="true"></span>');
                    _self.createOfferPin(_offerCode, _offerAmount, _el.parents('.pin-offer-item'));
                }
            });

            _self.searchForm.find('#searchTerm').prop({ 'disabled': false })

            _self.isInitialized = true;
        }
    },
    GetPinFromUrl: function (url) {
        var _self = TPS.DealerTools.PinSearch;
        var urlParams = new URLSearchParams(url);
        var pinFromUrl = urlParams.get('PIN');

        if (pinFromUrl) {
            _self.searchForm.find('#searchTerm').val(pinFromUrl);
            _self.findPin();
        }
    },
    findPin: function () {

        var _self = TPS.DealerTools.PinSearch;

        var _term = document.getElementById('searchTerm').value.trim();

        // Update URL
        var url = new URL(window.location.href);
        if (_term) {
            url.searchParams.set('PIN', _term);
        } else {
            url.searchParams.delete('PIN');
        }
        history.replaceState(null, '', url.toString());

        _self.searchForm.addClass('submitting');
        _self.resetSearchFormErrors();
        _self.searchResults.empty();

        CMSApp.AV.API.Pin.PinLookup(_term, _self.currentCulture,
            // On success
            function (data) {
                if (data) {

                    if (!data.Success && data.HasErrors) {
                        _self.addFormError(data.ErrorMessages[0].Value);
                    } else if (data.Object && data.Object.HasResults) {
                        _self.renderOfferResults(data.Object.Offers);
                        _self.renderPinResults(data.Object.Pins);
                    }
                }
                _self.searchForm.removeClass('submitting');
            },
            // On request fail
            function (data) {

                console.error(data._statusCode + " : " + data._message);

                _self.searchForm.removeClass('submitting');

            });

    },
    addFormError: function (_message) {
        var _self = TPS.DealerTools.PinSearch;

        var _input = _self.searchForm.find('#searchTerm');

        _input.addClass('form-control-error');
        _input.parent().append(`<span class="form-control-error" id="searchTerm-error">${_message}</span>`);
        _input.attr({
            'aria-invalid': 'true',
            'aria-describedby': 'searchTerm-error'
        });
    },
    handleValidatePinButton: function (_element) {
        var pinId = _element.data('pin-id');
        var secondaryPin = _element.data('program-secondarypin');
        var tertiaryPin = _element.data('program-tertiarypin');
        var newvehicle = _element.data('program-newvehicle');
        var demoloaner = _element.data('program-demoloaner');
        var certified = _element.data('program-certified');
        var overseas = _element.data('program-overseas');
        var offerCode = _element.data('offercode');
        var isFormPinStarted = _element.data('form-status');

        if (isFormPinStarted) {
            TPS.DealerTools.ValidatePinForm.init(secondaryPin, tertiaryPin, offerCode, _element);
        } else {
            TPS.DealerTools.VinSearch.OpenPinForm(_element, pinId, secondaryPin, tertiaryPin, newvehicle, demoloaner, certified, overseas, offerCode);
        }

        var $category = TPS.Forms.getFormVals('.' + TPS.DealerTools.ValidatePinForm.validatePinFormSelector).pinValidationCategory;
        if ($category != 'OSD' && $category != 'CBV') {
            jQuery(this).addClass('disabled');
        }
    },
    handleRevalidatePinButton: function (_element) {
        var pinGuid = _element.data('pinguid');
        var wrapper = _element.parent()
        var pinId = _element.data('pin-id');
        var secondaryPin = _element.data('program-secondarypin');
        var tertiaryPin = _element.data('program-tertiarypin');
        var newvehicle = _element.data('program-newvehicle');
        var demoloaner = _element.data('program-demoloaner');
        var certified = _element.data('program-certified');
        var overseas = _element.data('program-overseas');
        var offerCode = _element.data('offercode');
        var isFormPinStarted = _element.data('form-status');

        TPS.DealerTools.ValidatePinForm.reactivatePin(_element, pinGuid, wrapper, pinId, secondaryPin, tertiaryPin, newvehicle, demoloaner, certified, overseas, offerCode, isFormPinStarted);
    },
    resetSearchFormErrors: function () {
        var _self = TPS.DealerTools.PinSearch;

        var _input = _self.searchForm.find('#searchTerm');
        var _message = _self.searchForm.find('#searchTerm-error');

        _input.removeClass('form-control-error');
        _input.removeAttr('aria-invalid');
        _input.removeAttr('aria-describedby');
        _message.remove();

    },
    renderPinResults: function (_pins) {

        var _self = TPS.DealerTools.PinSearch;

        var _html = '';

        jQuery(_pins).each((_key, _pin) => {
            _html += _self.getPinItemHtml(_pin);
        });

        _self.searchResults.append(_html);

    },
    renderOfferResults: function (_offers) {

        var _self = TPS.DealerTools.PinSearch;

        var _html = '';

        jQuery(_offers).each((_key, _offer) => {

            // only render offers that are not claimed already
            if (_offer.OfferRedemptionStatus !== 'CLAIMED') {

                var _expirationDateFormatted = _self.formatDateTime(_offer.OfferEndDate);
                var _expirationDate = new Date(_offer.OfferEndDate);
                var _currentDate = new Date();
                var _isExpired = _currentDate.getTime() > _expirationDate.getTime();

                var _html_email = _offer.OfferCustomerEmail ? `<br/><a href="mailto:${_offer.OfferCustomerEmail}">${_offer.OfferCustomerEmail}</a>` : '';

                var _html_statusLabel = window.Labels.FormPinLookUp.OfferRedemptionStatus[_offer.OfferRedemptionStatus.trim().replace(/ /g, '')] ? window.Labels.FormPinLookUp.OfferRedemptionStatus[_offer.OfferRedemptionStatus.trim().replace(/ /g, '')] : _offer.OfferRedemptionStatus;

                var _html_modelsAlternate = window.Labels.FormPinLookUp.OfferAlternateModels_list.replace('{{primary_model}}', _offer.OfferModelName);

                var _html_modelsExcluded = '';
                if (_offer.OfferModelExclusions.length > 0) {
                    var _modelsEcludedList = '';
                    $(_offer.OfferModelExclusions).each((_mk, _model) => {
                        if (_mk > 0) {
                            _modelsEcludedList += '<br/>';
                        }
                        _modelsEcludedList += _model;
                    });

                    _html_modelsExcluded = `<div class="row pin-offer-item-exclusions">
                                                <div class="column tablet-5">
                                                    <h3>${window.Labels.FormPinLookUp.OfferExcludedModels}</h3>
                                                    <p>${_modelsEcludedList}</p>
                                                </div>                                        
                                            </div>`;

                    _html_modelsAlternate = window.Labels.FormPinLookUp.OfferAlternateModels_list_excluded.replace('{{primary_model}}', _offer.OfferModelName);
                }


                var _html_primaryOfferAction = `<a href="#" class="button small" data-offer-code="${_offer.OfferRedemptionCode}" data-offer-amount="${_offer.OfferIncentiveAmount}" data-action="create-offer-pin">${window.Labels.FormPinLookUp.OfferCreatePin}</a>`;
                var _html_altOfferAction = `<a href="#" class="button small" data-offer-code="${_offer.OfferRedemptionCode}" data-offer-amount="${_offer.OfferAltIncentiveAmount}" data-action="create-offer-pin">${window.Labels.FormPinLookUp.OfferCreatePin}</a>`;

                if (_isExpired) {
                    _html_primaryOfferAction = `<a href="javascript:void(0);" class="button small disabled" aria-disabled="true">${window.Labels.FormPinLookUp.OfferCreatePin}</a>`;
                    _html_altOfferAction = `<a href="javascript:void(0);" class="button small disabled" aria-disabled="true">${window.Labels.FormPinLookUp.OfferCreatePin}</a>`;
                }

                _html += `
                        <div class="pin-search-results-item pin-offer-item detail-page-section">
                            <div class="row column">
                                <h2 class="pin-search-results-item-number pin-number" data-pin="" data-pinid="">${window.Labels.FormPinLookUp.OfferItemHeadline} ${_offer.OfferRedemptionCode} <span class="heading-highlight">${_html_statusLabel}</span></h2>
                                <p class="pin-search-results-item-number-desc">
                                    ${window.Labels.FormPinLookUp.CampaignName} ${_offer.OfferCampaignName}
                                    <br/>${window.Labels.FormPinLookUp.OfferExpires} ${_expirationDateFormatted}
                                </p>
                            </div>
                            <div class="row">
                                <div class="column large-4">
                                    <h3>${window.Labels.FormPinLookUp.OfferIssuedTo}</h3>
                                    <p>
                                        <strong>${_offer.OfferCustomerName}</strong>
                                        ${_offer.OfferCustomerAddress ? '<br/>' + _offer.OfferCustomerAddress : ''}
                                        ${_offer.OfferCustomerCity || _offer.OfferCustomerState ? '<br/>' : ''}${_offer.OfferCustomerCity ? _offer.OfferCustomerCity : ''}${_offer.OfferCustomerCity && _offer.OfferCustomerState ? ', ' + _offer.OfferCustomerState : _offer.OfferCustomerState ? _offer.OfferCustomerState : ''}
                                        ${_offer.OfferCustomerZIP ? '<br/>' + _offer.OfferCustomerZIP : ''}
                                        ${_offer.OfferCustomerPhone ? '<br/>' + _offer.OfferCustomerPhone : ''}
                                        ${_html_email}
                                    <p>
                                </div>
                                <div class="column large-8">
                                        <div class="row pin-offer-item-primary">
                                            <div class="column tablet-5">
                                                <h3>${window.Labels.FormPinLookUp.OfferPrimaryModels}</h3>
                                                <p>${_offer.OfferModelName}</p>
                                            </div>
                                            <div class="column tablet-3 tablet-text-right">
                                                <h3>${window.Labels.FormPinLookUp.OfferAmount}</h3>
                                                <p>${_self.formatCurrency(_offer.OfferIncentiveAmount)}</p>
                                            </div>
                                            <div class="column tablet-4 text-center tablet-text-right">
                                                ${_html_primaryOfferAction}
                                            </div>
                                        </div>
                                        <div class="row pin-offer-item-alternate">
                                            <div class="column tablet-5">
                                                <h3>${window.Labels.FormPinLookUp.OfferAlternateModels}</h3>
                                                <p>${_html_modelsAlternate}</p>
                                            </div>
                                            <div class="column tablet-3 tablet-text-right">
                                                <h3>${window.Labels.FormPinLookUp.OfferAmount}</h3>
                                                <p>${_self.formatCurrency(_offer.OfferAltIncentiveAmount)}</p>
                                            </div>
                                            <div class="column tablet-4 text-center tablet-text-right">
                                                ${_html_altOfferAction}
                                            </div>
                                        </div>
                                        ${_html_modelsExcluded}
          
                                    
                                 </div>
                            </div>
                        </div>
                        `;
            }
        });

        _self.searchResults.append(_html);


    },
    createOfferPin: function (_offerCode, _offerAmount, _itemElem) {

        var _self = TPS.DealerTools.PinSearch;

        var _code = _offerCode.toString();
        var _amt = Number(_offerAmount);

        _self.offerCodeSent = true;

        CMSApp.AV.API.Pin.CreateEEQOfferPin(_code, _amt, _self.currentCulture,
            // On success
            function (data) {

                if (data) {

                    if (data.Success && !data.HasErrors) {
                        // replace the offer item in the list
                        // with the newly created PIN 
                        _itemElem.empty();
                        _itemElem.after(_self.getPinItemHtml(data.Object));
                        _itemElem.remove();

                    } else if (data.HasErrors) {
                        alert(data.ErrorMessages[0].Value);
                    }
                }
                // remove the loading icon from the button
                jQuery(`[data-offer-code="${_offerCode}"] .tps-icon`).remove();

                // reset blocker boolean
                _self.offerCodeSent = false;
            },
            // On request fail
            function (data) {
                //TPS.Forms.scrollToMessages(data._statusCode + " : " + data._message, false, TPS.GeneratePin.errorBlockSelector, '.hidden-magellan-error', true);
                console.error(data._statusCode + " : " + data._message);
                alert(`There was a problem creating the pin from this offer.`);
                // remove the loading icon from the button
                jQuery(`[data-offer-code="${_offerCode}"] .tps-icon`).remove();
                // reset blocker boolean
                _self.offerCodeSent = false;

            });
    },
    getPinItemHtml: function (_pin) {
        var _self = TPS.DealerTools.PinSearch;
        var programStatus = JSON.stringify(_pin.Program);
        var _html_externalID = "";

        var _html_email = _pin.Customer.Email.trim() !== '' && _pin.Partner.CompanyName != "Costco Volvo Affinity Offer" ? `<br/><a href="mailto:${_pin.Customer.Email}">${_pin.Customer.Email}</a>` : '';


        var _html_companyWeb = _pin.Partner.CompanyWeb ? `<br><a href="${_pin.Partner.CompanyWeb}">${_pin.Partner.CompanyWeb}</a>` : '';
        var _html_emailSponsor = _pin.Customer.SponsorEmail ? `<br/><a href="mailto:${_pin.Customer.SponsorEmail}">${_pin.Customer.SponsorEmail}</a>` : '';

        // show membership only for costco program
        if (_pin.Program.ProgramName && _pin.Program.ProgramName.includes("Costco") && _pin.Customer.CustomerExternalID) {
            _html_externalID = `<p>${window.Labels.FormPinLookUp.MembershipID}: ${_pin.Customer.CustomerExternalID}</p>`;
        }

        // setup the pin result buttons
        var _html_actions = "";
        if (_pin.Pin.PinStatus === 'ACTIVE') {
            var pinOffer = _pin.Offer.OfferRedemptionCode ? _pin.Offer.OfferRedemptionCode : '';
            _html_actions += TPS.DealerTools.ValidatePinForm.createValidatePinButton(
                'validatepin',
                _pin.Pin.PinID,
                _pin.Program.ProgramAllowSecondaryPin,
                _pin.Program.ProgramAllowTertiaryPin,
                _pin.Program.ProgramNewVehicleEnabled,
                _pin.Program.ProgramDemoLoanerEnabled,
                _pin.Program.ProgramCertifiedEnabled,
                _pin.Program.ProgramOverseasEnabled,
                pinOffer
            );
        }
        if (_pin.Pin.PinStatus === "VALIDATED") {
            _html_actions += `<a href="${_pin.Pin.PinDownloadUrl}" class="button download-pin-button" data-pin="${_pin.Pin.PinNumber}" data-action="downloadworksheet">${window.Labels.Buttons.DownloadWorksheet}</a>`;
            _html_actions += TPS.DealerTools.ValidatePinForm.createValidatePinButton(
                'revalidatepin',
                _pin.Pin.PinID,
                _pin.Program.ProgramAllowSecondaryPin,
                _pin.Program.ProgramAllowTertiaryPin,
                _pin.Program.ProgramNewVehicleEnabled,
                _pin.Program.ProgramDemoLoanerEnabled,
                _pin.Program.ProgramCertifiedEnabled,
                _pin.Program.ProgramOverseasEnabled,
                pinOffer,
                _pin.Pin.PinGuid,
                _pin.Program.ProgramOption
            );
        }
        
        // show the sponsor details
        // if they exist
        var _html_sponsorDetails = ``;
        if (_pin.Pin.PinRelationship > 0 && _pin.Pin.PinRelationship != 4) {
            _html_sponsorDetails = `
                    <div class="tablet-6 column">
                        <h3>${window.Labels.FormPinLookUp.PinSponsor}</h3>
                        <p>
                            <strong>${_pin.Customer.SponsorFirstName} ${_pin.Customer.SponsorLastName}</strong>
                            ${_pin.Customer.SponsorAddressLine1 ? '<br/>' + _pin.Customer.SponsorAddressLine1 : ''}
                            ${_pin.Customer.SponsorAddressCity || _pin.Customer.SponsorState ? '<br/>' : ''}${_pin.Customer.SponsorAddressCity ? _pin.Customer.SponsorAddressCity : ''}${_pin.Customer.SponsorAddressCity && _pin.Customer.SponsorState ? ', ' + _pin.Customer.SponsorState : _pin.Customer.SponsorState ? _pin.Customer.SponsorState : ''}
                            ${_pin.Customer.SponsorAddressZip ? '<br/>' + _pin.Customer.SponsorAddressZip : ''}
                            ${_pin.Customer.SponsorPhone ? '<br/>' + _pin.Customer.SponsorPhone : ''}
                            ${_html_emailSponsor}
                        </p>
                    </div>
                `;
        }

        // show the Special PIN Sponsor details
        // if they exist
        if (_pin.Pin.PinRelationship == 4) {
            _html_sponsorDetails = `
                    <div class="tablet-6 column">
                        <h3>${window.Labels.FormPinLookUp.PinSponsorSpecialPIN}</h3>
                        <p>
                            <strong>${_pin.Customer.SponsorDealerName}</strong>
                            <br/> ${_pin.Partner.CompanyName}
                            ${_html_emailSponsor}
                        </p>
                    </div>
                `;
        }


        // show the EEQ Offer details
        // if they exist
        var _html_offerDetails = ``;
        var _html_PinOfferCode = ``;
        if (_pin.Offer.OfferStatus !== null && _pin.Offer.OfferStatus !== '' && _pin.Offer.OfferStatus === 'CLAIMED') {
            var _html_offerModel = _pin.Offer.OfferModel && _pin.Offer.OfferYear ? `<strong>${window.Labels.FormPinLookUp.OfferDetails.Model}</strong> ${_pin.Offer.OfferYear} ${_pin.Offer.OfferModel}<br/>` : '';
            var _html_offerExpires = _pin.Offer.OfferExpires ? `<strong>${window.Labels.FormPinLookUp.OfferDetails.Expires}</strong> ${_self.formatDateTime(_pin.Offer.OfferExpires)}<br/>` : '';
            var _html_offerAmount = _pin.Offer.OfferAmount ? `<strong>${window.Labels.FormPinLookUp.OfferDetails.Amount}</strong> ${_self.formatCurrency(_pin.Offer.OfferAmount)}<br/>` : '';
            var _html_offerPromoID = _pin.Offer.OfferPromoID ? `<strong>${window.Labels.FormPinLookUp.ProgramInfo.PromoID}</strong> ${_pin.Offer.OfferPromoID}<br/>` : '';
            var _html_offerCode = _pin.Offer.OfferRedemptionCode ? `<strong>${window.Labels.FormPinLookUp.OfferDetails.Code}</strong> ${_pin.Offer.OfferRedemptionCode}<br/>` : '';
            var _html_offerBulletin = _pin.Offer.OfferBulletinNumber ? `<strong>${window.Labels.FormPinLookUp.ProgramInfo.Bulletin}</strong> ${_pin.Offer.OfferBulletinNumber}<br/>` : '';

            var _html_statusLabel = window.Labels.FormPinLookUp.OfferRedemptionStatus[_pin.Offer.OfferStatus.trim().replace(/ /g, '')] ? window.Labels.FormPinLookUp.OfferRedemptionStatus[_pin.Offer.OfferStatus.trim().replace(/ /g, '')] : _pin.Offer.OfferStatus;

            _html_offerDetails = `
                  <div class="tablet-4 column">
                        <h3>${window.Labels.FormPinLookUp.OfferDetails.Headline}</h3>
                        <p>
                            ${_html_offerModel}
                            ${_html_offerAmount}
                            ${_html_offerExpires}
                            ${_html_offerPromoID}
                            ${_html_offerCode}
                            ${_html_offerBulletin}
                        </p>
                    </div>
            `;

            _html_PinOfferCode = _pin.Offer.OfferRedemptionCode ? `<p class="pin-search-results-item-number-offercode">${window.Labels.FormPinLookUp.OfferCode} ${_pin.Offer.OfferRedemptionCode} - <span class="highlight">${_html_statusLabel}</span></p>` : '';

        } else {

            var _row_programType = _pin.Program.ProgramType ? `<strong>${window.Labels.FormPinLookUp.ProgramInfo.ProgramType} </strong>${_pin.Program.ProgramType}<br />` : '';
            var _row_programName = _pin.Program.ProgramName ? `<strong>${window.Labels.FormPinLookUp.ProgramInfo.ProgramInfoName} </strong>${_pin.Program.ProgramName}<br />` : '';
            var _row_bulletin = _pin.Offer.OfferBulletinNumber ? `<strong>${window.Labels.FormPinLookUp.ProgramInfo.Bulletin} </strong>${_pin.Offer.OfferBulletinNumber}<br />` : '';
            var _row_bulletinName = _pin.Offer.OfferBulletinName ? `<strong>${window.Labels.FormPinLookUp.ProgramInfo.BulletinName} </strong>${_pin.Offer.OfferBulletinName}<br />` : '';

            _html_offerDetails = `
                <div class="tablet-${_pin.Pin.PinRelationship > 0 ? "6" : "4"} column" >
                    <h3>${window.Labels.FormPinLookUp.ProgramInfo.PinProgramInfo}</h3>
                    <p>
                        ${_row_programType}
                        ${_row_programName}
                        ${_row_bulletin}
                        ${_row_bulletinName}
                    </p>
                </div >
            `;
        }

        // render different information
        // dependong on the Status of the PIN
        var _html_statusText = ``;
        var _html_extratext = ``
        if (_pin.Pin.PinStatus === "REDEEMED" || _pin.Pin.PinStatus === "REDEEMED WITHOUT VALIDATION") {
            // vehicle information
            _html_statusText = `
                  <div class="row">
                    <div class="column">
                        <h3>${window.Labels.FormPinLookUp.VehicleSalesInformation}</h3>
                        <p>
                            <strong>${window.Labels.FormPinLookUp.SoldModelYear}</strong> ${_pin.Pin.PinSoldModelYear ? _pin.Pin.PinSoldModelYear : window.Labels.FormPinLookUp.NotApplicable}<br>
                            <strong>${window.Labels.FormPinLookUp.SoldModelType}</strong> ${_pin.Pin.PinSoldModelType ? _pin.Pin.PinSoldModelType : window.Labels.FormPinLookUp.NotApplicable}<br>
                            <strong>${window.Labels.FormPinLookUp.SoldModelTrim}</strong> ${_pin.Pin.PinSoldModelTrim ? _pin.Pin.PinSoldModelTrim : window.Labels.FormPinLookUp.NotApplicable}<br>
                            <strong>${window.Labels.FormPinLookUp.SoldModelVIN}</strong> ${_pin.Pin.PinVin ? _pin.Pin.PinVin : window.Labels.FormPinLookUp.NotApplicable}<br>
                            <strong>${window.Labels.FormPinLookUp.SoldSalesType}</strong> ${_pin.Pin.PinSalesType ? _pin.Pin.PinSalesType : window.Labels.FormPinLookUp.NotApplicable}<br>
                            <strong>${window.Labels.FormPinLookUp.SoldDate}</strong> ${_pin.Pin.PinSoldAt ? _self.formatDateTime(_pin.Pin.PinSoldAt) : window.Labels.FormPinLookUp.NotApplicable}<br>
                            <strong>${window.Labels.FormPinLookUp.SoldPINCategory}</strong> ${_pin.Program.ProgramOptionValidated ? _pin.Program.ProgramOptionValidated : window.Labels.FormPinLookUp.NotApplicable}<br>
                            <strong>${window.Labels.FormPinLookUp.SoldPromoID}</strong> ${_pin.Program.ProgramPromoIDValidated ? _pin.Program.ProgramPromoIDValidated : window.Labels.FormPinLookUp.NotApplicable}<br>
                            <strong>${window.Labels.FormPinLookUp.SoldPINValue}</strong> ${_pin.Pin.PinValue ? _self.formatCurrency(_pin.Pin.PinValue) : window.Labels.FormPinLookUp.NotApplicable}<br>
                            ${_pin.Pin.SecondaryPinNumber && _self.currentCulture === "en-US" ? `<strong>${window.Labels.FormPinLookUp.AssociatedSecondaryPIN}</strong> ${_pin.Pin.SecondaryPinNumber}<br>` : ''}
                            ${_pin.Pin.SecondaryPinValue && _self.currentCulture === "en-US" ? `<strong>${window.Labels.FormPinLookUp.AssociatedSecondaryPINvalue}</strong> ${_self.formatCurrency(_pin.Pin.SecondaryPinValue)}<br>` : ''}
                            ${_pin.Pin.TertiaryPinNumber && _self.currentCulture === "en-US" ? `<strong>${window.Labels.FormPinLookUp.AssociatedTertiaryPIN}</strong> ${_pin.Pin.TertiaryPinNumber}<br>` : ''}
                        </p>
                    </div>
                  </div>
                `;
        }

        if (_pin.Pin.PinStatus === "ASSOCIATED SALE") {
            // Secondary PIN details
            _html_statusText = `
                    <div class="row validated-details">
                        <div class="column">
                            <h3>${window.Labels.FormPinLookUp.VehicleSalesInformation}</h3>
                            <p>
                            <strong>${window.Labels.FormPinLookUp.SaleAssociatedWithPrimaryPIN}:</strong> ${_pin.Pin.PrimaryPinNumber ? _pin.Pin.PrimaryPinNumber : window.Labels.FormPinLookUp.NotApplicable}
                            </p>
                        </div>
                    </div>
                `;
        }

        if (_pin.Pin.PinStatus === "VALIDATED" || _pin.Pin.PinStatus === "VALIDATED WITHOUT REDEMPTION" || _pin.Pin.PinStatus === "DENIED") {
            // Validator details

            var optionLabelValidated = window.Labels.FormPinLookUp.NotApplicable;
            if (_pin.Program.ProgramOptionValidated) {
                // get a localization key for the option label
                var labelKeyValidated = _pin.Program.ProgramOptionValidated.trim().replace(/ /g, '');
                optionLabelValidated = window.Labels.FormPinLookUp.PinProgramOption[labelKeyValidated] ? window.Labels.FormPinLookUp.PinProgramOption[labelKeyValidated] : _pin.Program.ProgramOptionValidated;
            }

            _html_statusText = `
                    <div class="row validated-details">
                        <div class="column">
                            <h3>${window.Labels.FormPinLookUp.SalesValidationInformation}</h3>
                            <p>
                                <strong>${window.Labels.FormPinLookUp.ValidatedBy}</strong> ${_pin.Pin.ValidatorEmail ? _pin.Pin.ValidatorEmail : window.Labels.FormPinLookUp.NotApplicable}<br/>
                                ${_pin.Pin.PinValidationDate ? `<strong>${window.Labels.FormPinLookUp.ValidatedDate}</strong> ${_self.formatDateTime(_pin.Pin.PinValidationDate)}<br/>` : ''}
                                <strong>${window.Labels.FormPinLookUp.ValidatedModelYear}</strong> ${_pin.Pin.PinVinVehicleYear ? _pin.Pin.PinVinVehicleYear : window.Labels.FormPinLookUp.NotApplicable}<br/>
                                <strong>${window.Labels.FormPinLookUp.ValidatedModelType}</strong> ${_pin.Pin.PinVinVehicleModel ? _pin.Pin.PinVinVehicleModel : window.Labels.FormPinLookUp.NotApplicable}<br/>
                                <strong>${window.Labels.FormPinLookUp.ValidatedModelTrim}</strong> ${_pin.Pin.PinVinVehicleTrim ? _pin.Pin.PinVinVehicleTrim : window.Labels.FormPinLookUp.NotApplicable}<br/>
                                <strong>${window.Labels.FormPinLookUp.ValidatedVinNumber}</strong> ${_pin.Pin.PinVinValidation ? _pin.Pin.PinVinValidation : window.Labels.FormPinLookUp.NotApplicable}<br>
                                <strong>${window.Labels.FormPinLookUp.ProgramOptionValidated}</strong> ${optionLabelValidated}<br>
                                <strong>${window.Labels.FormPinLookUp.ProgramPromoIDValidated}</strong> ${_pin.Program.ProgramPromoIDValidated ? _pin.Program.ProgramPromoIDValidated : window.Labels.FormPinLookUp.NotApplicable}<br>
                                ${_pin.Pin.PinValue ? `<strong>${window.Labels.FormPinLookUp.PINValue}</strong> ${_self.formatCurrency(_pin.Pin.PinValue)}<br>` : ''}
                                ${_pin.Pin.SecondaryPinNumber && _self.currentCulture === "en-US" ? `<strong>${window.Labels.FormPinLookUp.AssociatedSalePIN}</strong> ${_pin.Pin.SecondaryPinNumber}<br>` : ''}
                                ${_pin.Pin.SecondaryPinValue && _self.currentCulture === "en-US" ? `<strong>${window.Labels.FormPinLookUp.SecondaryPINValue}</strong> ${_self.formatCurrency(_pin.Pin.SecondaryPinValue)}<br>` : ''}
                                ${_pin.Pin.TertiaryPinNumber && _self.currentCulture === "en-US" ? `<strong>${window.Labels.FormPinLookUp.AssociatedTertiaryPIN}</strong> ${_pin.Pin.TertiaryPinNumber}<br>` : ''}
                                ${_pin.Pin.TertiaryPinValue && _self.currentCulture === "en-US" ? `<strong>${window.Labels.FormPinLookUp.TertiaryPINValue}</strong> ${_self.formatCurrency(_pin.Pin.TertiaryPinValue)}<br>` : ''}
                            </p>
                        </div>
                    </div>
                `;

            if (_pin.Pin.PinStatus === "DENIED") {
                _html_extratext = `<div class="row deny-reason">
                        <div class="column">
                            <p>
                                <strong>${window.Labels.FormPinLookUp.DenyReason}:</strong> ${_pin.Pin.PinStatusReason ? _pin.Pin.PinStatusReason : ''}<br/>
                            </p>
                        </div>
                    </div>`
            }
        }
        
         var _html = `
                    <div class="pin-search-results-item detail-page-section">
                         <div class="row column">
                              <h2 class="pin-search-results-item-number pin-number" data-pin="${_pin.Pin.PinNumber}" data-pinid="${_pin.Pin.PinID}">${window.Labels.FormPinLookUp.pin} ${_pin.Pin.PinNumber} <span class="heading-highlight">${window.Labels.FormPinLookUp.PinStatus[_pin.Pin.PinStatus.trim().replace(/ /g, '')]}</span></h2>
                              ${_html_PinOfferCode}
                              <p class="pin-search-results-item-number-desc">
                                ${_pin.Program.ProgramName}
                                <br/>${window.Labels.FormPinLookUp.expires} ${_pin.Pin.PinExpiration ? _self.formatDateTime(_pin.Pin.PinExpiration) : ''}
                              </p>
                          </div>

                          <div class="row pin-search-results-item-detail">
                            <div class="tablet-${_pin.Pin.PinRelationship > 0 ? "6" : "4"} column">
                              <h3>${window.Labels.FormPinLookUp.PinIssuedTo}</h3>
                              <p>
                                <strong>${_pin.Customer.Firstname ? _pin.Customer.Firstname : ''} ${_pin.Customer.Lastname ? _pin.Customer.Lastname : ''}</strong>
                                ${_pin.Customer.Address ? '<br/>' + _pin.Customer.Address : ''}
                                ${_pin.Customer.City || _pin.Customer.State ? '<br/>' : ''}${_pin.Customer.City ? _pin.Customer.City : ''}${_pin.Customer.City && _pin.Customer.State ? ', ' + _pin.Customer.State : _pin.Customer.State ? _pin.Customer.State : ''}
                                ${_pin.Customer.Zipcode ? '<br/>' + _pin.Customer.Zipcode : ''}
                                ${_pin.Customer.Phone ? '<br/>' + _pin.Customer.Phone : ''}
                                ${_html_email}
                              </p>
                              ${_html_externalID}
                            </div>

                            ${_html_sponsorDetails}
                            
                            <div class="tablet-${_pin.Pin.PinRelationship > 0 ? "6" : "4"} column">
                                <h3>${window.Labels.FormPinLookUp.PinPartnerCompany}</h3>
                                <p>
                                    <strong>${_pin.Partner.CompanyName}</strong>
                                    ${_pin.Partner.CompanyAddress ? '<br/>' + _pin.Partner.CompanyAddress : ''}
                                    ${_pin.Partner.CompanyCity || _pin.Partner.CompanyState ? '<br/>' : ''}${_pin.Partner.CompanyCity ? _pin.Partner.CompanyCity : ''}${_pin.Partner.CompanyCity && _pin.Partner.CompanyState ? ', ' + _pin.Partner.CompanyState : _pin.Partner.CompanyState ? _pin.Partner.CompanyState : ''}
                                    ${_pin.Partner.CompanyPhone ? '<br/>' + _pin.Partner.CompanyPhone : ''}
                                    ${_html_companyWeb}
                                </p>
                            </div>
                           
                            ${_html_offerDetails}                            
                        </div><!-- .row -->

                        ${_html_statusText}
                        ${_html_extratext}

                    <div class="validate-pin-actions pin-search-results-item-actions row column" data-program="${_pin.Program.ProgramOption ? _pin.Program.ProgramOption : ''}" data-pin="${_pin.Pin.PinNumber}" data-pinguid="${_pin.Pin.PinGuid}" data-offercode="${_pin.Offer.OfferRedemptionCode ? _pin.Offer.OfferRedemptionCode : ''}" data-program-status='${programStatus}' data-program-allowstacking='${_pin.Program.ProgramAllowSecondaryPin}'>
                        ${_html_actions}
                    </div>
                </div><!-- .pin-search-results-item -->
                `;
        return _html;
    },
    formatDateTime: function (_dateObj) {
        if (typeof _dateObj.getMonth !== 'function') {
            return _dateObj;
        }
        var _self = TPS.DealerTools.PinSearch;
        var _months = window.Labels.monthLabels ? window.Labels.monthLabels : _self.monthLabels;
        return `  ${_months[_dateObj.getMonth()]} ${_dateObj.getDate()}, ${_dateObj.getFullYear()}`;

    },
    formatCurrency: function (_amt) {

        var lang = document.getElementById('lng').value;

        if (typeof _amt !== 'number') {
            return _amt;
        }

        if (lang === 'fr-CA') {
            return `${_amt} $`; 
        }
        else {
            return `$${_amt}`
        }
    },
    populateEmailForm: function (pin, email) {

        var _self = TPS.DealerTools.PinSearch;

        jQuery(_self.emailFormSel).find("#hfPinNumber").val(pin);
        jQuery(_self.emailFormSel).find("#txtToAddress").val(email);

    }
}
